/* eslint-disable no-param-reassign */
import { Transforms } from 'slate';
import { CustomEditor, CustomElement, CustomText } from '../types';
import { fromHtml } from '../utils/html';

export const withHtml = (editor: CustomEditor) => {
	const { insertData, isInline, isVoid } = editor;

	// editor.isInline = (element: CustomElement) => {
	// 	return element.type === 'link' ? true : isInline(element);
	// };

	// editor.isVoid = (element: CustomElement) => {
	// 	return element.type === 'image' ? true : isVoid(element);
	// };

	// editor.insertData = (data) => {
	// 	const html = data.getData('text/html');

	// 	if (html) {
	// 		const fragments = fromHtml(html).filter((fragment: CustomText) => {
	// 			return !(Object.keys(fragment).length === 1 && fragment.text === '\n');
	// 		});
	// 		Transforms.insertFragment(editor, fragments);
	// 		return;
	// 	}

	// 	insertData(data);
	// };

	return editor;
};
